import { gql } from "lib/apolloClient";

export const createQuestionBankQuestionMutation = gql`
  mutation createQuestionBankQuestion($input: CreateQuestionInput!) {
    content {
      createQuestion(input: $input) {
        id
        questionType {
          id
          uid
          type
        }
        parentEntity {
          id
          ... on OrganizationResource {
            id
          }
        }
      }
    }
  }
`;

export const updateQuestionMutation = gql`
  mutation updateQuestion($input: UpdateQuestionInput!) {
    content {
      updateQuestion(input: $input) {
        id
      }
    }
  }
`;

export const createQuestionMutationV2 = gql`
  mutation createQuestionV2($input: CreateWorksheetQuestionInputV2!) {
    content {
      createQuestionV2(input: $input) {
        id
      }
    }
  }
`;
